import React from 'react';
import styles from '../../../event-timeline.module.css';

interface SceneLoadedParamsProps {
  params: any;
  setParams: (params: any) => void;
}

const SceneLoadedParams: React.FC<SceneLoadedParamsProps> = () => {
  return (
    <div className={styles.parameterContainer}>
      <span className={styles.label}>No parameters needed</span>
    </div>
  );
};

export default SceneLoadedParams;
